var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.dialog
    ? _c(
        "v-dialog",
        {
          staticClass: "pa-0",
          attrs: { scrim: false, width: "auto" },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            {
              staticClass: "d-flex flex-column justify-between",
              staticStyle: { "border-radius": "15px !important" },
              attrs: { width: "90vw" },
            },
            [
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-row",
                    { staticClass: "ma-0 pa-5", attrs: { align: "center" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", elevation: "0" },
                          on: { click: _vm.openMarketerDialog },
                        },
                        [
                          _c(
                            "v-row",
                            {
                              staticClass: "ma-0",
                              attrs: {
                                align: "center",
                                justify: "space-between",
                              },
                            },
                            [
                              _c("v-icon", [_vm._v("mdi-account-multiple")]),
                              _vm._v(" "),
                              _c("p", { staticClass: "ma-0" }, [
                                _vm._v("Makler zuweisen"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-spacer"),
                      _vm._v(" "),
                      !_vm.inCalcRoute
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "me-2",
                              attrs: { color: "orange", elevation: "0" },
                              on: { click: _vm.showCustomerDetail },
                            },
                            [
                              _c(
                                "v-icon",
                                {
                                  staticClass: "me-2",
                                  attrs: { color: "white", size: "20" },
                                },
                                [_vm._v("mdi-account-settings")]
                              ),
                              _vm._v(" "),
                              _c("span", { staticClass: "text-white" }, [
                                _vm._v("Navigator"),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { outlined: "" },
                          on: {
                            click: function ($event) {
                              _vm.dialog = false
                            },
                          },
                        },
                        [_vm._v("Schließen")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "ms-2",
                          attrs: {
                            disabled: !_vm.form,
                            loading: _vm.saving,
                            color: "primary",
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Speichern")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      model: {
                        value: _vm.form,
                        callback: function ($$v) {
                          _vm.form = $$v
                        },
                        expression: "form",
                      },
                    },
                    [
                      _c(
                        "v-card",
                        {
                          staticClass: "radius-10 position-relative mb-7",
                          attrs: { outlined: "", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "py-0 custom-negative-margin pt-2" },
                            [_vm._v("Kundeninformation")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 mt-3" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0",
                                  attrs: { align: "center", justify: "start" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.infoPacket,
                                          "loading-prop": _vm.fetching,
                                          label: "INFO-Paket",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "infoPacket",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "infoPacket",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.resend,
                                          "loading-prop": _vm.fetching,
                                          label: "Wiedervorlage",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "resend",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "resend",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.customerInterested,
                                          label: "Kunden-Ident",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "customerInterest-select",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .customerInterest,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "customerInterest",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.customerInterest",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          label: "Modell-Ident",
                                          items: _vm.modelIdent,
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test": "modelIdent-select",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit.modelIdent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "modelIdent",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.modelIdent",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.statuses,
                                          label: "Prozess Status",
                                          "item-text": "name",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          disabled: _vm.statuses.length === 0,
                                          "hide-details": "",
                                          "return-object": "",
                                          "data-test": "status-select",
                                        },
                                        model: {
                                          value: _vm.customerListEdit.status,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "customerListEdit.status",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _vm.customerListEdit?.externalMarketers
                                        ?.length > 0
                                        ? _c("v-text-field", {
                                            attrs: {
                                              label: "Makler",
                                              outlined: "",
                                              loading: _vm.fetching,
                                              "hide-details": "",
                                              readonly: "",
                                              "data-test":
                                                "external-marketer-name-textField",
                                            },
                                            model: {
                                              value: _vm.externalMarketersNames,
                                              callback: function ($$v) {
                                                _vm.externalMarketersNames = $$v
                                              },
                                              expression:
                                                "externalMarketersNames",
                                            },
                                          })
                                        : _c("v-text-field", {
                                            attrs: {
                                              label: "Inside Sales",
                                              outlined: "",
                                              loading: _vm.fetching,
                                              "hide-details": "",
                                              "data-test":
                                                "insideSales-textField",
                                            },
                                            model: {
                                              value:
                                                _vm.customerListEdit
                                                  .insideSales,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.customerListEdit,
                                                  "insideSales",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "customerListEdit.insideSales",
                                            },
                                          }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.salesArea,
                                          label: "Sales Area",
                                          "item-text": "area",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          disabled: _vm.salesArea.length === 0,
                                          "hide-details": "",
                                          "return-object": "",
                                          "data-test": "salesArea-select",
                                        },
                                        model: {
                                          value: _vm.customerListEdit.salesArea,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "salesArea",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.salesArea",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-currency-field", {
                                        attrs: {
                                          "decimal-length": 0,
                                          type: "number",
                                          label: "Immowert Kunde",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "valueFromCustomer-currency",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .valueFromCustomer,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "valueFromCustomer",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "customerListEdit.valueFromCustomer",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-currency-field", {
                                        attrs: {
                                          "decimal-length": 0,
                                          label: "Immowert Calc",
                                          type: "number",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "calculationValue-currency",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .calculationValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "calculationValue",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "customerListEdit.calculationValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "radius-10 position-relative mb-7",
                          attrs: { outlined: "", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "py-0 custom-negative-margin pt-2" },
                            [_vm._v("Sales Prozess")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 mt-3" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0",
                                  attrs: { align: "center", justify: "start" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.contactDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Kontakt",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contactDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contactDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.consultDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Beratungstermin",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "consultDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "consultDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit
                                              .unbindingOfferDate,
                                          "loading-prop": _vm.fetching,
                                          label: "unverbl. Angebot",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "unbindingOfferDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "unbindingOfferDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.appraiseDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Gutachten",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "appraiseDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "appraiseDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.brokerDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Maklerauftrag",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "brokerDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "brokerDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit
                                              .bindingOfferDate,
                                          "loading-prop": _vm.fetching,
                                          label: "verbl. Angebot",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "bindingOfferDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "bindingOfferDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit
                                              .contractDraftDate,
                                          "loading-prop": _vm.fetching,
                                          label: "KV-Entwurf",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contractDraftDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contractDraftDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.contractDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Kaufvertrag",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contractDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "contractDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "radius-10 position-relative mb-7",
                          attrs: { outlined: "", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "py-0 custom-negative-margin pt-2" },
                            [_vm._v("Estimate")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 mt-3" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0",
                                  attrs: { align: "center", justify: "start" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-currency-field", {
                                        attrs: {
                                          label: "ImmoWert EST",
                                          type: "number",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "estimatedPropertyValue-currency",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .estimatedPropertyValue,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "estimatedPropertyValue",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression:
                                            "customerListEdit.estimatedPropertyValue",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Provision",
                                          type: "number",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test": "provision-textField",
                                        },
                                        model: {
                                          value: _vm.customerListEdit.provision,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "provision",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.provision",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-select", {
                                        attrs: {
                                          items: _vm.chanceWeights,
                                          "item-text": "chance",
                                          type: "number",
                                          label: "Chance",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "return-object": "",
                                          "data-test": "chance-select",
                                        },
                                        model: {
                                          value: _vm.customerListEdit.chance,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "chance",
                                              $$v
                                            )
                                          },
                                          expression: "customerListEdit.chance",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit.estimate,
                                          "loading-prop": _vm.fetching,
                                          label: "estimate",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "estimate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "estimate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card",
                        {
                          staticClass: "radius-10 position-relative",
                          attrs: { outlined: "", elevation: "0" },
                        },
                        [
                          _c(
                            "v-card-title",
                            { staticClass: "py-0 custom-negative-margin pt-2" },
                            [_vm._v("Infoveranstaltung")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-text",
                            { staticClass: "pa-0 mt-3" },
                            [
                              _c(
                                "v-row",
                                {
                                  staticClass: "ma-0",
                                  attrs: { align: "center", justify: "start" },
                                },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("auto-validate-date-field", {
                                        attrs: {
                                          "reference-prop":
                                            _vm.customerListEdit
                                              .informationEventDate,
                                          "loading-prop": _vm.fetching,
                                          label: "Infoveranstaltung Datum",
                                        },
                                        on: {
                                          "update:referenceProp": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "informationEventDate",
                                              $event
                                            )
                                          },
                                          "update:reference-prop": function (
                                            $event
                                          ) {
                                            return _vm.$set(
                                              _vm.customerListEdit,
                                              "informationEventDate",
                                              $event
                                            )
                                          },
                                          "update:loadingProp": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                          "update:loading-prop": function (
                                            $event
                                          ) {
                                            _vm.fetching = $event
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Infoveranstaltung Ort",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "informationEventPlace-textField",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .informationEventPlace,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "informationEventPlace",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.informationEventPlace",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", md: "4" } },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          label: "Infoveranstaltung #TLN",
                                          outlined: "",
                                          loading: _vm.fetching,
                                          "hide-details": "",
                                          "data-test":
                                            "informationEvent-textField",
                                        },
                                        model: {
                                          value:
                                            _vm.customerListEdit
                                              .informationEvent,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.customerListEdit,
                                              "informationEvent",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "customerListEdit.informationEvent",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.showMarketerDialog
            ? _c(
                "v-dialog",
                {
                  attrs: { width: "40rem" },
                  model: {
                    value: _vm.showMarketerDialog,
                    callback: function ($$v) {
                      _vm.showMarketerDialog = $$v
                    },
                    expression: "showMarketerDialog",
                  },
                },
                [
                  _c(
                    "v-card",
                    {
                      staticClass: "ma-0 pa-0 fill-height radius-10",
                      attrs: { elevation: "0" },
                    },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "tertiary py-3" },
                        [
                          _c("span", [_vm._v("Externer makler")]),
                          _vm._v(" "),
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { icon: "" },
                              on: {
                                click: function ($event) {
                                  _vm.showMarketerDialog = false
                                },
                              },
                            },
                            [_c("v-icon", [_vm._v(" mdi-close ")])],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-text",
                        { staticClass: "pt-5" },
                        [
                          _c(
                            "div",
                            { staticClass: "mb-5" },
                            _vm._l(
                              _vm.selectedMarketers,
                              function (marketer, index) {
                                return _c(
                                  "v-chip",
                                  { key: index, staticClass: "me-3" },
                                  [
                                    _c(
                                      "v-row",
                                      {
                                        staticClass: "ma-0",
                                        attrs: {
                                          align: "center",
                                          justify: "space-between",
                                        },
                                      },
                                      [
                                        _c("p", { staticClass: "ma-0" }, [
                                          _vm._v(
                                            _vm._s(
                                              marketer?.user?.firstName +
                                                " " +
                                                marketer?.user?.lastName
                                            )
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: { icon: true },
                                            on: {
                                              click: function ($event) {
                                                return _vm.removeExternalMarketerFromCustomer(
                                                  marketer.id
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "v-icon",
                                              { attrs: { size: "small" } },
                                              [_vm._v("mdi-close")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }
                            ),
                            1
                          ),
                          _vm._v(" "),
                          _c("v-data-table", {
                            attrs: {
                              items: _vm.externalMarketers,
                              headers: _vm.externalHeaders,
                              loading: _vm.addingNewMarketerOnCustomer,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.plus`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { icon: "" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.addNewMarketerOnCustomer(
                                                item.marketerId
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("v-icon", [
                                            _vm._v("mdi-plus-circle-outline"),
                                          ]),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }